export enum VARIANTS {
  DEFAULT = 'default',
  FRAME = 'frame',
  GHOST = 'ghost',
  STACK = 'stack',
}
